/**
 * 头像处理 Composable
 */
import { getResourceUrl } from '@/utils/resource'

const DEFAULT_USER_AVATAR = '/user-avatar-default.svg'

export function useAvatar() {
  /**
   * 获取头像URL
   * 使用统一的资源URL处理逻辑
   */
  function getAvatarUrl(avatar?: string): string {
    const value = avatar?.trim()
    // 历史账号使用的默认 CDN 图已不可用；默认头像统一由前端提供，不覆盖个人上传图片。
    if (!value || value === DEFAULT_USER_AVATAR
      || /^https?:\/\/cdn\.paofu\.com\/avatar\/default\.png(?:[?#].*)?$/i.test(value)) {
      return DEFAULT_USER_AVATAR
    }
    return getResourceUrl(value) || DEFAULT_USER_AVATAR
  }

  return {
    getAvatarUrl,
  }
}


